import { render } from "./ComplianceCheckingDialogForDean.vue?vue&type=template&id=5b042485"
import script from "./ComplianceCheckingDialogForDean.vue?vue&type=script&lang=js"
export * from "./ComplianceCheckingDialogForDean.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__